// import { FaArrowUp } from "react-icons/fa";

export default function FooterForVerification() {
  return (
    <footer className="relative bg-gradient-to-r from-slate-900 to-slate-800 text-white">
      <div
        className="
          max-w-7xl mx-auto
          px-lg py-xl
          flex flex-col items-center gap-md
        "
      >
        {/* Copyright */}
        <p className="text-small text-text-muted">
          © 2026 © DSSL
        </p>

        {/* Footer Links */}
        <ul className="flex flex-wrap justify-center gap-2 text-body font-medium text-[14px] mb-3">
          <li className="hover:text-primary-hover transition cursor-pointer">
            <a href="https://verification.othm.org.uk/Pages/Privacy">Privacy</a>
          </li>
          <li className="hover:text-primary-hover transition cursor-pointer">
           
            <a href="https://verification.othm.org.uk/Pages/Faq">FAQ</a>
          </li>
          <li className="hover:text-primary-hover transition cursor-pointer">
           
            <a href="https://verification.othm.org.uk/Pages/Cookies"> Cookies</a>
          </li>
          <li className="hover:text-primary-hover transition cursor-pointer">
            
            <a href="https://verification.othm.org.uk/Pages/Terms">Terms</a>
          </li>
          <li className="hover:text-primary-hover transition cursor-pointer">
            
            <a href="https://verification.othm.org.uk/Pages/Support">Support</a>
          </li>
        </ul>
      </div>

      
    </footer>
  );
}
